import styled from "@emotion/styled";

export const MascotContainer = styled.div`
    width: fit-content;
    padding: 13px 16px;
    display: flex;
    align-items: center;
    gap: 20px;
    position: absolute;
    right: -220px;
    border-radius: 44px;
    background: rgba(255, 255, 255, 0.20);
    backdrop-filter: blur(14px);
    -webkit-backdrop-filter: blur(14px);  
`;

export const MascotItemWrapper = styled('div', {
    shouldForwardProp: (prop) => prop !== 'isSelected',
})<{ isSelected: boolean }>`
    display: flex;
    width: 58px;
    height: 47px;
    padding: 8px 6px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    border-radius: 50%;
    overflow: hidden;
    background: ${({ isSelected }) => isSelected ? 'rgba(255, 255, 255, 0.40)' : 'transparent'};
    cursor: pointer;

    img {
        width: 84px;
        height: 62px;
        object-fit: contain;
    }
`;

export const MascotImage = styled('img', {
    shouldForwardProp: (prop) => prop !== 'isSelected' && prop !== 'disableScale',
}) <{ isSelected: boolean; disableScale?: boolean }>`
    width: 80px;
    height: 55px;
    object-fit: contain;
    cursor: pointer;
    transition: filter 0.2s ease-in-out, transform 0.2s ease;

    ${({ isSelected }) => isSelected ? `
        filter: drop-shadow(0 0 3px rgba(255, 255, 255, 0.85));
    ` : ''}

    &:hover {
        filter: drop-shadow(0 0 3px rgba(255, 255, 255, 0.85));
        ${({ disableScale }) => !disableScale ? 'transform: scale(1.1);' : ''}
    }
`;

export const SelectorContainer = styled.div`
    position: relative;
    width: 80px;
    height: 55px;
`;
